export default __webpack_public_path__ + "static/media/research-game.aca2bfdb.jpg";